import { configureStore } from '@reduxjs/toolkit'
import counter from './counterSlice';
import zipcode from './zipcodeSlice';
import cart from './cartSlice';

export const store = configureStore({
  reducer: { counter, zipcode, cart }
})

export default store;